<template>
    <div id="progress-bar">
        <div id="progress" :style="style()"></div>
    </div>
</template>

<script>
export default {
  props: {
    neverEnding: Boolean
  },
  data () {
    return {
      elapsed: 0,
      total: 0
    }
  },
  methods: {
    start (elapsed, total, onUpdate) {
      // Reset
      this.elapsed = elapsed
      this.total = total

      // Create interval
      this.interval = setInterval(function () {
        // Clear interval
        if (this.elapsed + 1e9 > this.total) {
          clearInterval(this.interval)
          this.interval = null
          return
        }

        // Increment
        this.elapsed += 1e9

        // On update
        if (onUpdate) onUpdate(this.elapsed)
      }.bind(this), 1000)
    },
    stop () {
      // Clear interval
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },
    style () {
      var w = 0
      if (this.total > 0) {
        if (this.neverEnding && this.elapsed / this.total > 0.9) {
          w = 90
        } else {
          w = (this.elapsed / this.total * 100)
        }
      }
      return {
        width: w + '%'
      }
    }
  }
}
</script>

<style scoped>

#progress-bar {
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 0.3em;
    height: 0.3em;
    overflow: hidden;
    position: relative;
    width: 100%;
}

#progress {
    background-color: #ff6e14;
    height: 100%;
    transition: width 1s;
}

</style>
